<template>
  <div class="content">
    <Navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  name: 'DefaultLayout',
  components: { Navbar },
};
</script>
